import { AxiosResponse } from "axios";
import { WalletPaymentDto } from '../interfaces/wallet-payment.dto';
import http from "./http";

export default class WalletService {
  async walletPaymentFail(transactionId: string): Promise<void> {
    try {
      const response: AxiosResponse = await http.post(`${process.env.REACT_APP_BASE_URL}wallet/payment-fail`,
        {
          transactionId
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async walletPaymentSuccess(
    // transactionId: string, receipt: string, 
    answerId?: number): Promise<WalletPaymentDto> {
    try {
      const response: AxiosResponse = await http.post(`${process.env.REACT_APP_BASE_URL}wallet/payment-success`,
        {
          answerId,
          // transactionId,
          // receipt
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async login(walletToken: string): Promise<{ token: string }> {
    try {
      const response: AxiosResponse = await http.post(
        `${process.env.REACT_APP_BASE_URL}wallet/login`,
        {
          code: walletToken
        },
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
